import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _additionalData = {
    currentMember: '_member',
    currentUserReview: '_enrichedLiveSiteReview',
    overallRatingSummary: '_attributeSummary',
    config: '_configuration',
    reviewRequestRecipientReview: '_enrichedLiveSiteReview',
};
var _attributeSummary = { average: 'DOUBLE' };
var _configuration = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _createReviewAndContactRequest = {};
var _createReviewAndContactResponse = { response: '_createReviewResponse' };
var _createReviewResponse = { review: '_review' };
var _deleteReviewResponse = { review: '_review' };
var _deleteVoteRequest = {};
var _deleteVoteResponse = { response: '_votesDeleteVoteResponse' };
var _downvoteRequest = {};
var _downvoteResponse = { response: '_votesDownvoteResponse' };
var _enrichedLiveSiteReview = {
    review: '_review',
    currentUserVotes: '_vote',
};
var _entityAverage = { average: 'DOUBLE' };
var _getEntityRequest = {};
var _getEntityResponse = { additionalData: '_additionalData' };
var _getReviewByIdRequest = {};
var _getReviewByIdResponse = {
    review: '_enrichedLiveSiteReview',
    additionalData: '_additionalData',
};
var _listAttributeAveragesByEntityResponse = {
    entityAverages: '_entityAverage',
};
var _listReviewsByEntityIdRequest = {};
var _listReviewsByEntityIdResponse = {
    reviews: '_enrichedLiveSiteReview',
    additionalData: '_additionalData',
};
var _member = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lastLoginDate: 'google.protobuf.Timestamp',
};
var _removeReplyResponse = { review: '_review' };
var _reply = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _review = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    reviewDate: 'google.protobuf.Timestamp',
    relevanceScore: 'google.protobuf.DoubleValue',
    reply: '_reply',
};
var _setReplyResponse = { review: '_review' };
var _updateReviewContentRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _updateReviewContentResponse = { response: '_updateReviewResponse' };
var _updateReviewResponse = { review: '_review' };
var _upvoteRequest = {};
var _upvoteResponse = { response: '_votesUpvoteResponse' };
var _v1DeleteReviewRequest = {};
var _v1DeleteReviewResponse = { response: '_deleteReviewResponse' };
var _v1ListAttributeAveragesByEntityRequest = {};
var _v1ListAttributeAveragesByEntityResponse = {
    response: '_listAttributeAveragesByEntityResponse',
};
var _v1RemoveReplyRequest = {};
var _v1RemoveReplyResponse = { response: '_removeReplyResponse' };
var _v1SetReplyRequest = {};
var _v1SetReplyResponse = { response: '_setReplyResponse' };
var _vote = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _votesDeleteVoteResponse = { vote: '_vote' };
var _votesDownvoteResponse = { vote: '_vote' };
var _votesUpvoteResponse = { vote: '_vote' };
function resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/reviews-middleware',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/reviews-middleware/v1/bm/reviews',
                destPath: '/v1/bm/reviews',
            },
            {
                srcPath: '/_api/reviews-middleware/v1/bm/bulk/reviews',
                destPath: '/v1/bm/bulk/reviews',
            },
            {
                srcPath: '/_api/reviews-middleware/v1/bm/review-requests',
                destPath: '/v1/bm/review-requests',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/reviews-middleware/v1/reviews',
                destPath: '/v1/reviews',
            },
            {
                srcPath: '/_api/reviews-middleware/v1/bm/reviews',
                destPath: '/v1/bm/reviews',
            },
            {
                srcPath: '/_api/reviews-middleware/v1/bm/bulk/reviews',
                destPath: '/v1/bm/bulk/reviews',
            },
            {
                srcPath: '/_api/reviews-middleware/v1/bm/review-requests',
                destPath: '/v1/bm/review-requests',
            },
        ],
        _: [
            {
                srcPath: '/_api/reviews-middleware/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/reviews-middleware/v1/reviews',
                destPath: '/v1/reviews',
            },
            {
                srcPath: '/_api/reviews-middleware/v1/bm/bulk/reviews',
                destPath: '/v1/bm/bulk/reviews',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/reviews-middleware/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/reviews-middleware/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/reviews-middleware/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getReviewById(payload) {
    var _a = serializer(_getReviewByIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReviewByIdResponse, {
        _additionalData: _additionalData,
        _attributeSummary: _attributeSummary,
        _configuration: _configuration,
        _enrichedLiveSiteReview: _enrichedLiveSiteReview,
        _member: _member,
        _reply: _reply,
        _review: _review,
        _vote: _vote,
    }).fromJSON;
    function __getReviewById(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'GET',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.GetReviewById',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/{request.reviewId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReviewById.fromReq = fromReq;
    __getReviewById.__isAmbassador = true;
    return __getReviewById;
}
export function listReviewsByEntityId(payload) {
    var _a = serializer(_listReviewsByEntityIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listReviewsByEntityIdResponse, {
        _additionalData: _additionalData,
        _attributeSummary: _attributeSummary,
        _configuration: _configuration,
        _enrichedLiveSiteReview: _enrichedLiveSiteReview,
        _member: _member,
        _reply: _reply,
        _review: _review,
        _vote: _vote,
    }).fromJSON;
    function __listReviewsByEntityId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'GET',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.ListReviewsByEntityId',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/list-reviews-by-entity-id',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listReviewsByEntityId.fromReq = fromReq;
    __listReviewsByEntityId.__isAmbassador = true;
    return __listReviewsByEntityId;
}
export function getEntity(payload) {
    var _a = serializer(_getEntityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEntityResponse, {
        _additionalData: _additionalData,
        _attributeSummary: _attributeSummary,
        _configuration: _configuration,
        _enrichedLiveSiteReview: _enrichedLiveSiteReview,
        _member: _member,
        _reply: _reply,
        _review: _review,
        _vote: _vote,
    }).fromJSON;
    function __getEntity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'GET',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.GetEntity',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/entity/{entityId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEntity.fromReq = fromReq;
    __getEntity.__isAmbassador = true;
    return __getEntity;
}
export function createReviewAndContact(payload) {
    var _a = serializer(_createReviewAndContactRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createReviewAndContactResponse, {
        _createReviewResponse: _createReviewResponse,
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __createReviewAndContact(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'POST',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.CreateReviewAndContact',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReviewAndContact.fromReq = fromReq;
    __createReviewAndContact.__isAmbassador = true;
    return __createReviewAndContact;
}
export function updateReviewContent(payload) {
    var _a = serializer(_updateReviewContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReviewContentResponse, {
        _reply: _reply,
        _review: _review,
        _updateReviewResponse: _updateReviewResponse,
    }).fromJSON;
    function __updateReviewContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'PUT',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.UpdateReviewContent',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/content/{reviewId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReviewContent.fromReq = fromReq;
    __updateReviewContent.__isAmbassador = true;
    return __updateReviewContent;
}
export function listAttributeAveragesByEntity(payload) {
    var _a = serializer(_v1ListAttributeAveragesByEntityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1ListAttributeAveragesByEntityResponse, { _entityAverage: _entityAverage, _listAttributeAveragesByEntityResponse: _listAttributeAveragesByEntityResponse }).fromJSON;
    function __listAttributeAveragesByEntity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'POST',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.ListAttributeAveragesByEntity',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/ratings/groups/{request.group}/attributes/average',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAttributeAveragesByEntity.fromReq = fromReq;
    __listAttributeAveragesByEntity.__isAmbassador = true;
    return __listAttributeAveragesByEntity;
}
export function upvote(payload) {
    var _a = serializer(_upvoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upvoteResponse, {
        _vote: _vote,
        _votesUpvoteResponse: _votesUpvoteResponse,
    }).fromJSON;
    function __upvote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'POST',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.Upvote',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/votes/upvote',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upvote.fromReq = fromReq;
    __upvote.__isAmbassador = true;
    return __upvote;
}
export function downvote(payload) {
    var _a = serializer(_downvoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_downvoteResponse, {
        _vote: _vote,
        _votesDownvoteResponse: _votesDownvoteResponse,
    }).fromJSON;
    function __downvote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'POST',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.Downvote',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/votes/downvote',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __downvote.fromReq = fromReq;
    __downvote.__isAmbassador = true;
    return __downvote;
}
export function deleteVote(payload) {
    var _a = serializer(_deleteVoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteVoteResponse, {
        _vote: _vote,
        _votesDeleteVoteResponse: _votesDeleteVoteResponse,
    }).fromJSON;
    function __deleteVote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'DELETE',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.DeleteVote',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/votes/{request.voteId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteVote.fromReq = fromReq;
    __deleteVote.__isAmbassador = true;
    return __deleteVote;
}
export function deleteReview(payload) {
    var _a = serializer(_v1DeleteReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1DeleteReviewResponse, {
        _deleteReviewResponse: _deleteReviewResponse,
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __deleteReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'DELETE',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.DeleteReview',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/{request.reviewId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteReview.fromReq = fromReq;
    __deleteReview.__isAmbassador = true;
    return __deleteReview;
}
export function setReply(payload) {
    var _a = serializer(_v1SetReplyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1SetReplyResponse, {
        _reply: _reply,
        _review: _review,
        _setReplyResponse: _setReplyResponse,
    }).fromJSON;
    function __setReply(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'PATCH',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.SetReply',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/{request.reviewId}/reply',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setReply.fromReq = fromReq;
    __setReply.__isAmbassador = true;
    return __setReply;
}
export function removeReply(payload) {
    var _a = serializer(_v1RemoveReplyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1RemoveReplyResponse, {
        _removeReplyResponse: _removeReplyResponse,
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __removeReply(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.enriched_live_site_review',
            method: 'DELETE',
            methodFqn: 'wix.critique.reviews.middleware.v1.ReviewsLiveSiteMiddleware.RemoveReply',
            url: resolveWixCritiqueReviewsMiddlewareV1ReviewsLiveSiteMiddlewareUrl({
                protoPath: '/v1/reviews/{request.reviewId}/reply',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeReply.fromReq = fromReq;
    __removeReply.__isAmbassador = true;
    return __removeReply;
}
//# sourceMappingURL=http.impl.js.map